module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/reg-login/~/babel-runtime/core-js/promise.js
// module id = 523
// module chunks = 0